import React from 'react';
import Styles from './score-marker-styles.scss';
function formatNumber(numero) {
    try {
        return numero.toFixed(1);
    }
    catch (_a) {
        return '0';
    }
}
const ScoreMarker = ({ title = 'ScoreMarker', backgroundColor = 'green', percentage = 0 }) => {
    return (React.createElement("div", { className: `${Styles.scoreMarkerWrap} ${Styles[backgroundColor]}` },
        React.createElement("h3", { className: Styles.title }, title),
        React.createElement("div", { className: Styles.number },
            React.createElement("span", null,
                formatNumber(percentage),
                "%"))));
};
export default ScoreMarker;
